export default "__VITE_ASSET__52fe7956__"